import { useCallback, useEffect, useReducer } from "react";
import { initialState, panelReducer } from "./facilitatorPanelReducer";
import { getFacilitatorPanelData } from "@/api/panelService";
import { parseApiError } from "@/utils/errorHandler";

export const useFacilitatorPanel = () => {
    const [state, dispatch] = useReducer(panelReducer, initialState);

    const fetchData = useCallback(async () => {
        dispatch({ type: "FETCH_START" });
        try {
            const data = await getFacilitatorPanelData();
            dispatch({ type: "SET_DATA", payload: data });
            dispatch({ type: "FETCH_SUCCESS" });
        } catch (err) {
            const formattedError = parseApiError(err);
            dispatch({ type: "FETCH_FAILURE", payload: formattedError });
        }
    }, []);

    useEffect(() => {
        fetchData();
    }, [fetchData]);

    return {
        panelData: state.data,
        isLoading: state.isLoading,
        error: state.error,
        simulationIdForPerformance: state.simulationIdForPerformance,
    };
};
